'use client';

import React, { forwardRef, type HTMLAttributes } from 'react';
import {
  Button2 as Button,
  IconButton2 as IconButton,
} from 'components/Button2';
import type { ButtonProps } from 'components/Button2/Button2';
import type { IconButtonProps } from 'components/Button2/IconButton';
import styled from 'styled-components';
import { IconX } from '@frameio/vapor-icons';
import { theme } from '@frameio/vapor-theme';
import { ToastButtonCloseContainer } from './ToastContents.styled';

type ButtonGroupProps = HTMLAttributes<HTMLDivElement>;

const ToastButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
  <Button ref={ref} variant="secondary" {...props} />
));
// allow easier debugging for consumers
ToastButton.displayName = 'ToastButton';

const StyledDiv = styled.div`
  display: flex;
  gap: ${theme.spaces[8]};
`;

const ToastButtonGroup = (props: ButtonGroupProps) => <StyledDiv {...props} />;

type ToastCloseButtonProps = Omit<IconButtonProps, 'icon' | 'variant'>;
/**
 * @description A close button for Toast components
 */
function ToastCloseButton({ label, onPress }: ToastCloseButtonProps) {
  return (
    <ToastButtonCloseContainer>
      <IconButton
        data-testid="toast-alert--close-button"
        icon={<IconX />}
        label={label}
        onPress={onPress}
        variant="tertiary"
      />
    </ToastButtonCloseContainer>
  );
}
export type { ButtonGroupProps, ToastCloseButtonProps };
export { ToastButton, ToastButtonGroup, ToastCloseButton };
